const BASE_URL = "https://manage.guppytheatre.com"
export function url(path) {
    console.log("env", BASE_URL)
    let baseUrl = new URL(BASE_URL)
    baseUrl.pathname = path
    return baseUrl.toString()
}